import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Aplikasirestoran: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi Restoran" />
    <h1><strong><a href="/aplikasirestoran/">Aplikasi Restoran</a></strong></h1>
<img className="img-fluid" alt="aplikasi restoran cafe rumah makan" src="/img/mesinkasironlineapp6.jpg"/>
    <p>
     Sempurnakan kebutuhan usaha kuliner dengan <a href="/aplikasirestoran/">aplikasi restoran</a> kami , sangat membantu untuk pengusaha bisnsi restoran cafe rumah makan dan sejenis nya, berbagai variant system siap untuk digunakan mulai dari fastfood mode penjualan langsung, penggunaan pembagian divisi waiters kasir admin menjadikan kesempurnaan dalam bekerja via web app kami untuk digunakan, pada paket premium dan standard nikmati layanan tanpa batas include website yang terintegrasi secara otomatis dan langsung dengan <a href="/aplikasirestoran/">aplikasi restoran cafe rumah makan</a> , plus tentunya dukungan QR code menu digital dan android apk menyempurnakan segala nya.
    </p>
    <p>Mulai pilih applikasi resto mu sekarang, dan nikmati kebebasan point of sale app akses tanpa batas.</p>
<div className="row">
    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi restoran" 
src="https://1.bp.blogspot.com/-V7E1DP8HSCY/YKnlpB3J1DI/AAAAAAAAOHo/l1iyNmn4K8s2TeYCkxe7HWSZtdUEgoqxgCLcBGAsYHQ/s1484/aplikasi%2Brestoran%2Bterbaru%2Bnew%2Blengkap%2Bmupdate%2Brestaurant%2Bpos%2Bapps.jpg"/>
    </div>
    
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    MR.RESTO POS APPs<br/>
    Solusi terlengkap untuk usaha kuliner dengan berbagai dukungan fitur tersedia mulai dari waiters order, kitchen display, penjualan kasir, dan laporan laporan detail dan semakin keren dengan penjualan support gambar foto menu makanan minuman.
</p>
<Link to="/resto-mr/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi restoran" 
src="https://mesinkasironline.web.app/img/aplikasi%20restoran%20online%20web%20app.jpg"/>
    </div>
    
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    RESTO-X APPS<br/>
Temukan kemudahan dan kecepatan dengan menggunakan aplikasi resotran terbaik ini, simple digunakan dan mendukung penuh akan penjualan bergambar foto menu makanan minuman hingga kebutuhan untuk pencatatan keuangan detail hadir bersama resto-x web apps.
</p>
<Link to="/resto-x/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi restoran" 
src="https://mesinkasironline.web.app/img/mesin%20software%20kasir%20restoran%20cafe%20online1.jpg"/>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    BOOSTERPOS RESTO APPS<br/>
Simple mudah digunakan dengan dukungan bill list, pencatatan meja dan keterangan atau nama pelanggan semakin bebas dengan menggunakan boosterpos resto apps ini, dan tentunya terintegrasi secara langsung dengan website memudahkan handling all in one.
</p>
<Link to="/appresto/" className="button">More info</Link>
    </div>

    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi restoran" 
src="https://mesinkasironline.web.app/img/resto%20pos%20web%20app.png"/>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    DEXOPOS RESTO APPS<br/>
Kebutuhan dengan desktop mode dan dukungan clouds database memudahkan untuk support dengan mobile waiters app dalam bekerja , dengan modern desain UI plus laporan , aplikasi ini sangat simple dan mudah untuk pengguna awal.
</p>
<Link to="/dexoresto/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi restoran" 
src="https://mesinkasironline.web.app/img/restaurant%20apps.png"/>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    UNIPOS RESTO APPS<br/>
Mudah kan dan sempurnakan dengan dukungan software program restoran desktop terintegrasi dengan backoffice admin clouds apps plus website content management system di dalam nya, saatnya menggunakan unipos untuk kebutuhan terbaik.
</p>
<Link to="/unipos/" className="button">More info</Link>
    </div>
    </div>
    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Aplikasirestoran

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
